import isArray from 'lodash/isArray';
import set from 'lodash/set';
import Vue from 'vue';
import {TYPE_PDF} from '@/contants/base';

export const setList = (state, payload) => state.list = payload
export const updateList = (state, payload) => {
  Object.assign(state.list.data.find(item => item.id === payload.id), payload);
}
export const removeItem = (state, id) => state.list.data = state.list.data.filter(item => item.id !== id);
export const addField = (state, payload) => {
  state.application.fields.push(payload)
}
export const setFields = (state, payload) => state.application.fields = payload
export const updateField = (state, {id, payload}) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === id);

  Object.assign(state.application.fields[fieldIndex], payload);
};
export const setApplication = (state, payload) => state.application = payload
export const addInstanceToField = (state, payload) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === payload.mst_field_id);

  state.application.fields[fieldIndex].instances.push(payload);
}
export const updatePositionInstanceField = (state, payload) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === payload.mst_field_id);
  const instanceIndex = state.application.fields[fieldIndex].instances.findIndex(item => item.id === payload.id);

  Object.assign(state.application.fields[fieldIndex].instances[instanceIndex], payload);
}
export const updateInstanceField = (state, payload) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === payload.mst_field_id);
  const instanceIndex = state.application.fields[fieldIndex].instances.findIndex(item => item.id === payload.id);

  Object.assign(state.application.fields[fieldIndex].instances[instanceIndex], payload);

  state.application.questions.map(question => {
    const fieldGroupIndex = question.field_groups.findIndex(group => group.id === payload.field_group_id);
    if (fieldGroupIndex < 0) {
      return;
    }

    const targetField = question.field_groups[fieldGroupIndex].fields?.find(field => field.id === payload.id);
    if (targetField) Object.assign(targetField, payload);

    return question;
  });
}
export const updateOptionsForInstanceField = (state, {id, fieldId, payload}) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === fieldId);
  const instanceIndex = state.application.fields[fieldIndex].instances.findIndex(item => item.id === id);

  Object.assign(state.application.fields[fieldIndex].instances[instanceIndex].options, payload);
}
export const deleteField = (state, fieldId) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === fieldId);

  state.application.fields.splice(fieldIndex, 1);
}
export const removeInstanceFromList = (state, {id, fieldId}) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === fieldId);

  state.application.fields[fieldIndex].instances = state.application.fields[fieldIndex].instances.filter(item => {
    return item.id !== id;
  })
}
export const setQuestions = (state, payload) => state.application.questions = payload;
export const updateQuestion = (state, payload) => {
  Object.assign(state.application.questions.find(question => question.id === payload.id), payload);
}
export const addQuestion = (state, payload) => state.application.questions.push(payload);
export const removeQuestion = (state, questionId) => {
  state.application.questions = state.application.questions.filter(question => question.id !== questionId);
}
export const setQuestionNotification = (state, payload) => state.application.question_notification = payload;
export const setSurveyQuestionFields = (state, {questionId, payload}) => {
  return state.application.questions.find(question => question.id === questionId).survey_question_fields = payload;
}
export const addSurveyQuestionField = (state, payload) => {
  payload = isArray(payload) ? payload : [payload];
  
  state.application.questions.find(question => question.id === payload[0].question_id).survey_question_fields.push(...payload)
}
export const updateSurveyQuestionField = (state, payload) => {
  Object.assign(
    state.application.questions.find(question => question.id === payload.question_id).survey_question_fields.find(survey => survey.id === payload.id),
    payload
  )
}
export const removeSurveyQuestionField = (state, {surveyQuestionFieldId, questionId}) => {
  const question = state.application.questions.find(question => question.id === questionId);
  const surveyQuestionFields = question.survey_question_fields.filter(group => group.id !== surveyQuestionFieldId);

  return state.application.questions.find(question => question.id === questionId).survey_question_fields = surveyQuestionFields;
}
export const setFieldGroups = (state, {questionId, payload}) => {
  return state.application.questions.find(question => question.id === questionId).field_groups = payload;
}
export const addFieldGroup = (state, payload) => {
  payload = isArray(payload) ? payload : [payload];

  state.application.questions.find(question => question.id === payload[0].question_id).field_groups.push(...payload)
}
export const updateFieldGroup = (state, payload) => {
  Object.assign(
    state.application.questions.find(question => question.id === payload.question_id).field_groups.find(group => group.id === payload.id),
    payload
  )

  payload.fields.forEach(fieldPayload => {
    const mstField = state.application.fields.find(f => f.id === fieldPayload.mst_field_id);
    if (!mstField) return;

    mstField.instances.forEach(instance => {
      if (instance.id === fieldPayload.id) {
        instance.field_group_id = payload.id;
      }
    });
  });
}
export const removeFieldGroup = (state, {fieldGroupId, questionId}) => {
  const question = state.application.questions.find(question => question.id === questionId);
  const fieldGroups = question.field_groups.filter(group => group.id !== fieldGroupId);

  return state.application.questions.find(question => question.id === questionId).field_groups = fieldGroups;
}
export const saveOptionForQuestion = (state, payload) => {
  Object.assign(state.application.questions.find(question => question.id === payload.question_id).options, payload);
}
export const saveOptionForFieldGroup = (state, payload) => {
  Object.assign(
    state.application.questions.find(question => question.id === payload.question_id)
      .field_groups.find(group => group.id === payload.field_group_id).options,
    payload.options
  );
}
export const saveOptionForField = (state, payload) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === payload.mst_field_id);
  const instanceIndex = state.application.fields[fieldIndex].instances.findIndex(item => item.id === payload.id);

  Object.assign(state.application.fields[fieldIndex].instances[instanceIndex].options, payload.options);

  if (!payload.field_group_id) return;
  state.application.questions.map(question => {
    const fieldGroupIndex = question.field_groups.findIndex(group => group.id === payload.field_group_id);
    if (fieldGroupIndex < 0) return;

    const targetField = question.field_groups[fieldGroupIndex].fields?.find(field => field.id === payload.id);
    if (targetField) Object.assign(targetField.options, payload.options);

    return question;
  });
}
export const updateFieldOptionForQuestion = (state, {questionId, payload}) => {
  state.application.questions.find(question => question.id === questionId)
    .field_groups.find(group => group.id === payload.field_group_id)
    .fields.find(field => field.id === payload.id)
    .options = payload.options
}
export const removeFieldForQuestion = (state, {questionId, groupId, fieldIds}) => {
  const questionIndex = state.application.questions.findIndex(question => question.id === questionId);
  const fieldGroupIndex = state.application.questions[questionIndex]
    .field_groups.findIndex(group => group.id === groupId);

  state.application.questions[questionIndex].field_groups[fieldGroupIndex].fields =
    state.application.questions[questionIndex].field_groups[fieldGroupIndex].fields.filter(field => {
      return !fieldIds.includes(field.id);
    });
}
export const setFieldsForQuestion = (state, {questionId, groupId, payload}) => {
  state.application.questions.find(question => question.id === questionId)
    .field_groups.find(group => group.id === groupId)
    .fields = payload
}

export const removeFieldInstancesFromIdList = (state, list) => {
  state.application.fields.forEach(field => {
    field.instances = field.instances.filter(instance => !list.includes(instance.id))
  })
}

export const setFilePath = (state, {fileId, path}) => {
  const fileIndex = state.application.files.findIndex(file => file.id === fileId);
  state.application.files[fileIndex].path = path;
}

export const addFile = (state, payload) => {
  state.application.files.push(payload);
}

export const updateWordFileConfig = (state, { index, config }) => {
  state.application.files[index].config = config
}

export const updatePublishById = (state, { id, publish }) => {
  const findIndex = state.list.data.findIndex(item => item.id === id);
  state.list.data[findIndex].publish = publish;
}

export const setFile = (state, file) => {
  state.file = file;
}

export const setPdfFilePages = (state, {fileId, pages}) => {
  const file = state.application.files?.find(item => item.id === fileId);
  if (!file || file.config?.type !== TYPE_PDF) return;

  Vue.set(file, 'pages', pages);
  if (state.file?.id === fileId && state.file !== file) {
    Vue.set(state.file, 'pages', pages);
  }
}

export const setFiles = (state, files) => {
  state.application.files = files;
};

export const setFolders = (state, folders) => {
  state.application.folders = folders;
};

export const setQuestionIdToHighlightVariant = (state, questionId) => state.highlightVariant.questionId = questionId;

export const setFieldIdToHighlightVariant = (state, fieldId) => state.highlightVariant.fieldId = fieldId;

export const setQuestionToInstance = (state, {fieldId, instanceId, payload}) => {
  state.application.fields.find(field => field.id === fieldId)
    .instances.find(instance => instance.id === instanceId)
    .question = payload;
}

export const setFieldGroupIdToInstance = (state, {fieldId, instanceId, payload}) => {
  state.application.fields.find(field => field.id === fieldId)
    .instances.find(instance => instance.id === instanceId)
    .field_group_id = payload;
}

export const updateFileConfig = (state, {fileId, needConfirm, options, name}) => {
  const file = state.application.files.find(file => file.id === fileId);
  file.name = name;
  file.config.options = options;
  file.config.needConfirm = needConfirm;
  if (file?.folder_id) {
    const folder = state.application.folders.find(folder => folder.id === file.folder_id);
    if (folder?.files) {
      const f = folder.files.find(f => f.id === fileId);
      if (f) {
        f.name = name;
        f.config.options = options;
        f.config.needConfirm = needConfirm;
      }
    }
  }
}

export const updateInstanceOptions = (state, {key, value, instance}) => {
  const fieldIndex = state.application.fields.findIndex(field => field.id === instance.mst_field_id);
  const instanceIndex = state.application.fields[fieldIndex].instances.findIndex(item => item.id === instance.id);

  set(state.application.fields[fieldIndex].instances[instanceIndex], key, value);
}

export const setRules = (state, payload) => state.application.rules = payload;

export const addRule = (state, rule) => {
  state.application.rules.push(rule);
}

export const updateRule = (state, rule) => {
  const index = state.application.rules.findIndex(item => item.id === rule.id);
  Object.assign(state.application.rules[index], rule)
}

export const updatePlanPrice = (state, {index, data}) => {
  state.planPrices[index] = data;
}

export const pushPlanPrice = (state, data) => {
  state.planPrices.push(data);
}

export const setAllApplication = (state, payload) => state.allApplication = payload;

export const setAppUser = (state, payload) => state.appUser = payload;
export const setListAppUser = (state, payload) => state.listAppUser = payload;

export const setQuantityAppUser = (state, payload) => state.quantityAppUser = payload;

export const setListFilterTransaction = (state, payload) => state.listFilterTransaction = payload;
export const setListFilterStep = (state, payload) => state.listFilterStep = payload;
export const setCampaignEmailTemplate = (state, payload) => state.campaignEmailTemplate = payload;

export const addModal = (state, payload) => {
  state.application.modals.push(payload);
}
export const updateModal = (state, payload) => {
  const modal = state.application.modals.find(
    modal => modal.id === payload.id
  );
  if (modal) {
    Object.assign(modal, payload);
  }
}
export const removeModal = (state, id) => {
  state.application.modals = state.application.modals.filter((modal) => modal.id != id);
}
export const saveModalForQuestion = (state, payload) => {
  const question = state.application.questions.find(q => q.id === payload.id);
  if (question) question.modal_id = payload.modal_id;
}
export const saveModalForFieldGroup = (state, payload) => {
  const fieldGroup = state.application.questions
    .find(q => q.id === payload.question_id)
    ?.field_groups.find(g => g.id === payload.id);
  if (fieldGroup) fieldGroup.modal_id = payload.modal_id;
}
export const saveModalForSurveyField = (state, payload) => {
  const surveyField = state.application.questions
    .find(q => q.id === payload.question_id)
    ?.survey_question_fields.find(f => f.id === payload.id);
  if (surveyField) surveyField.modal_id = payload.modal_id;
}
